function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.1379 14.08C25.9062 14.08 28.1504 13.1631 28.1504 12.0322C28.1504 10.9012 25.9062 9.98438 23.1379 9.98438C20.3695 9.98438 18.1253 10.9012 18.1253 12.0322C18.1253 13.1631 20.3695 14.08 23.1379 14.08Z",
  stroke: "#45DB5D",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M28.1504 15.356C28.1504 16.0467 27.351 16.6561 26.0558 16.9812C25.1053 17.2452 24.1232 17.3738 23.1378 17.3631C22.1551 17.3732 21.1758 17.2447 20.2279 16.9812C18.9567 16.6155 18.1333 16.0061 18.1333 15.356",
  stroke: "#45DB5D",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M23.5056 20.7599C24.3568 20.7393 25.2024 20.6137 26.0238 20.3861C27.295 20.0123 28.1264 19.4028 28.1264 18.7202",
  stroke: "#45DB5D",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M23.5056 24.0589C24.3601 24.0399 25.2088 23.9116 26.0318 23.677C27.3029 23.3113 28.1264 22.71 28.1264 22.0518",
  stroke: "#45DB5D",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M18.1253 17.8263V12.0242",
  stroke: "#45DB5D",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M28.1504 12.0322V25.3429C28.1504 26.4237 26.1198 27.3014 23.5296 27.3745",
  stroke: "#45DB5D",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M16.8622 23.3602C19.6305 23.3602 21.8747 22.4434 21.8747 21.3124C21.8747 20.1815 19.6305 19.2646 16.8622 19.2646C14.0938 19.2646 11.8496 20.1815 11.8496 21.3124C11.8496 22.4434 14.0938 23.3602 16.8622 23.3602Z",
  stroke: "#45DB5D",
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M21.9067 24.644C21.9067 25.3266 21.1073 25.9361 19.8121 26.3099C18.8608 26.57 17.8793 26.6985 16.8941 26.6918C15.9116 26.6991 14.9327 26.5706 13.9842 26.3099C12.713 25.9361 11.8816 25.3266 11.8816 24.644",
  stroke: "#45DB5D",
  strokeLinejoin: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M21.9067 21.3123V27.9676C21.9067 28.6583 21.1072 29.2597 19.8041 29.6335C18.8563 29.8976 17.8769 30.0262 16.8941 30.0154C15.9114 30.0262 14.932 29.8976 13.9842 29.6335C12.713 29.2597 11.8816 28.6583 11.8816 27.9676V21.3123",
  stroke: "#45DB5D",
  strokeLinejoin: "round"
});

var SvgTotalTablet = function SvgTotalTablet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTotalTablet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/total-tablet.ec1c6d7b.svg";
export { ForwardRef as ReactComponent };